export const selectSuggestions = (state) => state.suggestionReducer.suggestion;
